import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import styled, { mediaQuery } from 'src/styles'
import { ComponentStyleProps } from 'src/types'

type Props = {
  interview: {
    avatar: any
    title: string
    message: string
    name: string
  }
} & ComponentStyleProps

export const StaffMessage: React.FC<Props> = (props) => {
  const { interview } = props
  return (
    <ScWrapper>
      <ScImg fluid={interview.avatar.childImageSharp.fluid} alt="" />
      <ScMessageWrapper>
        <ScTitle>{interview.title}</ScTitle>
        <ScMessage>{interview.message}</ScMessage>
        <ScName>{interview.name}</ScName>
      </ScMessageWrapper>
    </ScWrapper>
  )
}

const ScWrapper = styled.div`
  margin-bottom: 1.5rem;
  ${mediaQuery('sm')} {
    display: flex;
    align-items: flex-start;
    margin-right: 80px;
    margin-left: 80px;
    margin-bottom: 2.5rem;
    &:nth-of-type(even) {
      flex-direction: row-reverse;
    }
  }
`

const ScImg = styled(GatsbyImage)`
  width: 100%;
  ${mediaQuery('sm')} {
    width: 432px;
  }
`

const ScMessageWrapper = styled.div`
  background-color: #f7f7f7;
  flex: 1;
  padding: 24px;
  ${mediaQuery('sm')} {
    margin-top: 2.5rem;
    padding: 2.5rem;
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }
`

const ScTitle = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1em;
  ${mediaQuery('sm')} {
    font-size: 1.125rem;
  }
`

const ScMessage = styled.div`
  font-size: 0.875rem;
  margin-bottom: 1em;
  text-align: justify;
  white-space: pre-line;
`

const ScName = styled.p`
  color: #555;
  font-size: 0.875rem;
  text-align: right;
`
